import React from 'react'

import { StatusTag } from '@components/common/StatusTag'
import { TableCell } from '@components/common/TableCell'
import { VirtualProductThumbnail } from '@components/common/VirtualProductThumbnail'
import { TableItemDate } from '@components/utils/TableItemDate'
import type { TableHeaders } from '@fourthwall/components'
import { PriceString, ProfitString } from '@fourthwall/components'
import type { GetDonationsResponse } from '@fourthwall/services/dist/DonationApiClient'

import type { Status } from '../../../../../../../../../consts/status'

export const getTableHeaders = ({
  hideProfitColumn,
  timezoneAbbreviation,
}: {
  hideProfitColumn: boolean
  timezoneAbbreviation: string
}): TableHeaders<GetDonationsResponse['donations'][number]> => [
  {
    id: 'date',
    label: `Date (${timezoneAbbreviation})`,
    render: ({ createdAt }) => (
      <div>
        <TableItemDate date={createdAt} />
      </div>
    ),
  },
  {
    id: 'icon',
    label: ' ',
    render: () => {
      return (
        <div style={{ width: 60, height: 80 }}>
          <VirtualProductThumbnail />
        </div>
      )
    },
  },
  {
    id: 'supporter',
    label: 'Supporter',
    render: ({ username, email }) => {
      return username || email
    },
    width: 2,
  },
  {
    id: 'status',
    label: 'Status',
    render: ({ status }) => {
      return <StatusTag status={status as Status} />
    },
    width: 2,
  },
  {
    id: 'total',
    label: 'Total',
    render: ({ donation }) => {
      return <PriceString value={donation.value} />
    },
  },
  {
    id: 'profit',
    hidden: hideProfitColumn,
    label: 'Profit',
    render: ({ profit }) => (
      <TableCell mainContent={profit ? <ProfitString value={profit.value} /> : <>&ndash;</>} />
    ),
  },
]
